import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import ScrollToTop from './Component/ScrollToTop'
// import './Css/CommonFont.css'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './Css/CommonContainer.css'
const client = new ApolloClient({
  uri: window.globalConfig.GRAPHQL_URL,
  cache: new InMemoryCache(),
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ApolloProvider client={client}>
    <BrowserRouter basename='/hoe'>
    <ScrollToTop/>
      <App />
    </BrowserRouter>
  </ApolloProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorkerRegistration.unregister();
reportWebVitals();
